var map = {
	"./Box.jpg": 369,
	"./Frame 3481.png": 1055,
	"./LOGO@2x.png": 1056,
	"./arrow-down-blue.svg": 1057,
	"./arrow-down-grey.svg": 1058,
	"./arrow-down.svg": 1059,
	"./arrow-right-white.png": 1060,
	"./arrow-right.svg": 1061,
	"./arrow-up.svg": 1062,
	"./bg.png": 1063,
	"./bg_black.png": 370,
	"./binance-logo.png": 1064,
	"./binance.svg": 1065,
	"./blue-loader.svg": 1066,
	"./bnb_logo.png": 281,
	"./btn_menu_close.png": 1067,
	"./circle-grey.svg": 1068,
	"./circle.svg": 1069,
	"./close.png": 278,
	"./coinbaseWalletIcon.svg": 365,
	"./copy.png": 364,
	"./core_logo.png": 228,
	"./coy.png": 229,
	"./coy_logo.png": 119,
	"./dropdown-blue.svg": 1070,
	"./dropdown.svg": 1071,
	"./dropup-blue.svg": 1072,
	"./ethereum-logo.png": 1073,
	"./fortmaticIcon.png": 367,
	"./huobi-logo.png": 282,
	"./icon_arrow_right.png": 283,
	"./icon_bubble.png": 284,
	"./icon_cat.png": 285,
	"./icon_earth.png": 227,
	"./icon_edit.png": 226,
	"./icon_history.png": 371,
	"./icon_ques.png": 360,
	"./icon_rank.png": 372,
	"./icon_re.png": 373,
	"./icon_refresh.png": 374,
	"./icon_wallet.png": 536,
	"./image_flip.png": 1074,
	"./link.png": 1075,
	"./link.svg": 1076,
	"./loading.gif": 230,
	"./logo-pipi-dark.png": 1077,
	"./logo-pipi-light.png": 1078,
	"./logo.jpg": 362,
	"./logo.png": 1079,
	"./logo_text.jpg": 1080,
	"./logo_text.png": 1081,
	"./logob.png": 1082,
	"./logoh.png": 1083,
	"./logow.png": 1084,
	"./magnifying-glass.svg": 1085,
	"./menu-light.png": 1086,
	"./menu.png": 361,
	"./menu.svg": 1087,
	"./metamask.png": 375,
	"./mobile-menu-bg.png": 1088,
	"./nav-back.png": 363,
	"./ok-logo.png": 376,
	"./pledge_bg.png": 1089,
	"./plus-blue.svg": 1090,
	"./plus-grey.svg": 1091,
	"./polygon-logo.png": 377,
	"./portisIcon.png": 368,
	"./question-mark.svg": 1092,
	"./question.svg": 1093,
	"./spinner.svg": 1094,
	"./theme-day.png": 1095,
	"./theme-night.png": 1096,
	"./trustWallet.png": 1097,
	"./user-logo-gray.png": 1098,
	"./user_logo_gray.jpg": 1099,
	"./walletConnectIcon.svg": 366,
	"./wbnb.png": 1100,
	"./x.svg": 1101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;